import React from "react";

import {
  Box,
  TextField,
  InputAdornment,
} from "@mui/material";

import SearchIcon from "@mui/icons-material/Search";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined";
import FlagOutlinedIcon from "@mui/icons-material/FlagOutlined";
import CategoryOutlinedIcon from "@mui/icons-material/CategoryOutlined";
import SortOutlinedIcon from "@mui/icons-material/SortOutlined";

import AppButton from "../../ui/AppButton";
import AppSelect from "../../ui/AppSelect";
import {
  STATUS_OPTIONS,
  PRIORITY_OPTIONS,
  CATEGORY_OPTIONS,
  SORT_OPTIONS,
} from "../../constants/filterOptions";

function TicketFilters({
  search,
  setSearch,

  status,
  setStatus,

  priority,
  setPriority,

  category,
  setCategory,

  sortBy,
  setSortBy,

  onApply,
  onReset
}) {
  return (
    <Box
      sx={{
        bgcolor: "background.paper",
        border: "1px solid",
        borderColor: "divider",
        borderRadius: 2,
        p: 1.5,
        mb: 2
      }}
    >
      <TextField
        fullWidth
        size="small"
        placeholder="Search by ticket title, ID or employee name..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon fontSize="small" />
            </InputAdornment>
          )
        }}
        sx={{ mb: 1.5, "& .MuiInputBase-root": { height: 38 } }}
      />

      <Box display="flex" alignItems="flex-end" flexWrap="wrap" gap={1.5}>
        <AppSelect
          label="Status"
          icon={FactCheckOutlinedIcon}
          options={STATUS_OPTIONS}
          value={status}
          onChange={setStatus}
          minWidth={160}
        />

        <AppSelect
          label="Priority"
          icon={FlagOutlinedIcon}
          options={PRIORITY_OPTIONS}
          value={priority}
          onChange={setPriority}
          minWidth={160}
        />

        <AppSelect
          label="Category"
          icon={CategoryOutlinedIcon}
          options={CATEGORY_OPTIONS}
          value={category}
          onChange={setCategory}
          minWidth={160}
        />

        <AppSelect
          label="Sort By"
          icon={SortOutlinedIcon}
          options={SORT_OPTIONS}
          value={sortBy}
          onChange={setSortBy}
          minWidth={160}
        />

        <Box flexGrow={1} />

        <AppButton variant="outlined" onClick={onReset}>
          Reset
        </AppButton>

        <AppButton variant="contained" startIcon={<FilterAltIcon />} onClick={onApply}>
          Apply Filters
        </AppButton>
      </Box>
    </Box>
  );
}

export default TicketFilters;
